import { MESSAGES, type AppLocale, type MessageKey } from './messages';

/** System call-status lines stored as chat text; sender locale is baked into ciphertext — remap on display. */
const CALL_EVENT_MESSAGE_KEYS: MessageKey[] = [
  'callEventMissedOutgoing',
  'callEventMissedIncoming',
  'callEventDeclinedOutgoing',
  'callEventBusy',
  'callEventEnded',
];

const LOCALES: AppLocale[] = ['en', 'ru', 'sr', 'fr'];

/**
 * Строка события звонка — на языке зрителя.
 *
 * <p>Новые события звонка пишут длительность после « · » («📞 Call ended · 3:12») и «отменённый»
 * через «📞 » + строку истории — их узнаём тоже. Полноценный разбор события (кто звонил,
 * красный пропущенный) — в `calls/callEvents.ts`; здесь только текст для мест, где кроме текста
 * показать нечего.
 */
export function resolveCallEventTextForDisplay(
  raw: string,
  t: (key: MessageKey) => string,
): string {
  const trimmed = raw.trim();
  if (!trimmed.startsWith('📞')) return raw;

  for (const locale of LOCALES) {
    for (const key of CALL_EVENT_MESSAGE_KEYS) {
      const phrase = MESSAGES[locale][key];
      if (phrase === trimmed) {
        return t(key);
      }
      if (key === 'callEventEnded' && trimmed.startsWith(`${phrase} · `)) {
        return `${t(key)}${trimmed.slice(phrase.length)}`;
      }
    }
    if (trimmed === `📞 ${MESSAGES[locale].callHistCancelled}`) {
      return `📞 ${t('callHistCancelled')}`;
    }
  }
  return raw;
}
